import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

export const Subtitle = styled(Typography)`
  padding-bottom: 20px;
`;

export const Title = styled(Typography)`
  padding-bottom: 20px;
`;

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: between;
  vertical-align: center;
  padding-bottom: 20px;
`;
